module.exports = __webpack_public_path__ + "img/league_violation.34e4b233.svg";